import React, { useState, useEffect } from 'react';
import * as styles from './styles.scss';

const MaxSaleQtyMessage = ({ className, isMax, message }) => {
    const [isShow, setIsShow] = useState(null);

    useEffect(() => {
        let handler = null;

        if (isShow === null) {
            setIsShow(false);
        } else if (isMax) {
            setIsShow( true);
            handler = setTimeout(() => setIsShow(false), 5000);
        }

        return () => {
            setIsShow(false);
            clearTimeout(handler);
        }
    }, [isMax]);

    return (
        isShow &&
        <div className={`${styles.sale}${className ? ` ${className}` : ''}`}>
            {message}
        </div>
    );
};

export default MaxSaleQtyMessage;
